import React from "react";
import "./HeroSection.css";
import { Button, useMediaQuery } from "@mui/material";
import { getLoanData } from "../getLoanData";

const HeroSection = () => {
  const isSmallScreen = useMediaQuery(" (max-width:576px) ");
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  return (
    <>
      <div
        className="increase-margines"
        style={{
          backgroundColor: "#E7E4F9",
          borderRadius: 5,
          padding: isSmallScreen ? 30 : 40,
          marginTop: "2%",
          marginBottom: "4%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            backgroundColor: "transparent",
          }}
        >
          <p
            className="minutes mb-2"
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isMediumScreen ? 28 : 32,
              fontWeight: 600,
            }}
          >
            {getLoanData[0].heroSectionHeading}
          </p>
          <p
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isSmallScreen ? 16 : 18,
              fontWeight: 400,
              lineHeight: "",
            }}
          >
            {getLoanData[0].heroSectionSubHeading}
          </p>
          <div className=" d-flex flex-column align-items-start gap-3">
            <Button
              fullWidth={false}
              sx={{
                backgroundColor: "#553285",
                color: "white",
                borderRadius: 2,
                padding: isSmallScreen ? "10px 25px" : "10px 40px",
                fontFamily: "Archivo",
                fontWeight: 500,
                fontSize: 14,
                textTransform: "none",
              }}
              onClick={() => {
                window.location.href =
                  "https://minemi.ai/personal-loan/check-eligibility";
              }}
            >
              Check Eligibility Without Impacting Credit Score
            </Button>
            <Button
              fullWidth={false}
              sx={{
                backgroundColor: "#553285",
                color: "white",
                borderRadius: 2,
                padding: isSmallScreen ? "10px 25px" : "10px 40px",
                fontFamily: "Archivo",
                fontWeight: 500,
                fontSize: 14,
                textTransform: "none",
              }}
              onClick={() => {
                window.location.href = "https://minemi.ai/adcampaign/";
              }}
            >
              Check if you can take a top up for your requirement
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
